export default __webpack_public_path__ + "static/project-zeesh-b609f30df4c850e7db8edc1ec2d59e1d.png";